import Natural from "./Natural"
import Sharp from "./Sharp"

const WholeNote = ({x, y, width, sharp, natural}) => {
    return (
        <g stroke="#000000" strokeWidth={2} fill="#FFFFFF">
            {(sharp) ? <Sharp x={x - width * 1.5} y={y} width={width / 3 * 2} height={width / 4 * 3}/> : <g />}
            {(natural) ? <Natural x={x - width * 1.5} y={y} width={width / 3 * 2} height={width / 4 * 3}/> : <g />}
            <ellipse cx={x - width / 2} cy={y} rx={width / 2} ry={(width - 2) / 2}/>
        </g>
    )
}

export default WholeNote